(() => {
  const bindDisclosures = (root) => {
    root.querySelectorAll('[data-cp-disclosure]').forEach((button) => {
      if (button.dataset.cpBound) return;
      button.dataset.cpBound = 'true';
      button.addEventListener('click', () => {
        const panel = document.getElementById(button.getAttribute('aria-controls'));
        const expanded = button.getAttribute('aria-expanded') === 'true';
        button.setAttribute('aria-expanded', String(!expanded));
        if (panel) panel.hidden = expanded;
      });
    });
  };

  const bindVideos = (root) => {
    root.querySelectorAll('[data-cp-video-play]').forEach((button) => {
      if (button.dataset.cpBound) return;
      button.dataset.cpBound = 'true';
      button.addEventListener('click', () => {
        const media = button.closest('[data-cp-video-media]');
        const template = media && media.querySelector('template');
        const video = template && template.content.querySelector('video');
        if (!video) return;
        const player = video.cloneNode(true);
        media.querySelectorAll('[data-cp-video-overlay]').forEach((element) => element.remove());
        media.appendChild(player);
        player.focus();
        const playback = player.play();
        if (playback && playback.catch) playback.catch(() => {});
      });
    });
  };

  const bindCopyLinks = (root) => {
    root.querySelectorAll('[data-cp-copy-link]').forEach((button) => {
      if (button.dataset.cpBound) return;
      button.dataset.cpBound = 'true';
      const label = button.textContent;
      const status = button.parentElement.querySelector('[data-cp-copy-status]');
      button.addEventListener('click', async () => {
        try {
          await navigator.clipboard.writeText(button.dataset.cpCopyLink);
        } catch (error) {
          return;
        }
        button.textContent = button.dataset.cpCopiedLabel;
        if (status) status.textContent = button.dataset.cpCopiedLabel;
        window.setTimeout(() => {
          button.textContent = label;
          if (status) status.textContent = '';
        }, 3000);
      });
    });
  };

  const init = (root) => {
    bindDisclosures(root);
    bindVideos(root);
    bindCopyLinks(root);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document));
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
